export default __webpack_public_path__ + "static/media/logotype-white.2a456de7.svg";